<template>
  <div class="flex items-center">    
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">
      <span>{{ params.data.teacher.name }}</span>
      <span>&nbsp;</span>
      <span>{{ params.data.teacher.last_name }}</span>
    </router-link>
  </div>
</template>

<script>
    export default {
        name: 'CellRendererLink',
        computed: {
          url() {
            return "/teachers/"+this.params.data.id
          }
        }
    }
</script>
